import { render, staticRenderFns } from "./educationResultInfo.vue?vue&type=template&id=0c2bb019"
import script from "./educationResultInfo.vue?vue&type=script&lang=js"
export * from "./educationResultInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c2bb019')) {
      api.createRecord('0c2bb019', component.options)
    } else {
      api.reload('0c2bb019', component.options)
    }
    module.hot.accept("./educationResultInfo.vue?vue&type=template&id=0c2bb019", function () {
      api.rerender('0c2bb019', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/result/educationResultInfo.vue"
export default component.exports